import { ProfileSectionConfig } from "./dashboard.types";

export const DEFAULT_PROFILE_SECTIONS: ProfileSectionConfig[] = [
  {
    key: "private-profiles",
    title: "Private Profiles",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-slate-50 to-purple-50",
    navButtonClass: "bg-purple-600 text-white hover:bg-purple-700",
    buttonClass: "border-2 border-purple-600 text-purple-600 hover:bg-purple-50",
    countColorClass: "text-purple-600",
    statusBadgeClass: "bg-purple-100 text-purple-700",
    viewAllPath: "/admin/profiles/all?filter=private",
  },
  {
    key: "my-male",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-purple-50 to-blue-50",
    navButtonClass: "bg-purple-600 text-white hover:bg-purple-700",
    buttonClass:
      "border-2 border-purple-600 text-purple-600 hover:bg-purple-50",
    countColorClass: "text-purple-600",
    viewAllTextKey: "dashboard.buttons.viewAllMale",
    statusBadgeClass: "bg-white/90 text-purple-700 shadow",
    viewAllPath: "/admin/profiles/male?filter=inactive",
  },

  {
    key: "my-female",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-pink-50 to-purple-50",
    navButtonClass: "bg-pink-500 text-white hover:bg-pink-600",
    buttonClass: "border-2 border-pink-500 text-pink-600 hover:bg-pink-50",
    countColorClass: "text-pink-600",
    viewAllTextKey: "dashboard.buttons.viewAllFemale",
    statusBadgeClass: "bg-white/90 text-pink-600 shadow",
    viewAllPath: "/admin/profiles/female?filter=inactive",
  },
  {
    key: "callback-profiles",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-amber-50 to-yellow-50",
    navButtonClass: "bg-amber-500 text-white hover:bg-amber-600",
    buttonClass: "border-2 border-amber-500 text-amber-600 hover:bg-amber-50",
    countColorClass: "text-amber-600",
    viewAllTextKey: "dashboard.buttons.viewAllCallBack",
    statusBadgeClass: "bg-amber-500 text-white shadow-md",
    viewAllPath: "/admin/profiles/callback",
  },
  {
    key: "not-responding-profiles",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-rose-50 to-pink-50",
    navButtonClass: "bg-rose-500 text-white hover:bg-rose-600",
    buttonClass: "border-2 border-rose-500 text-rose-600 hover:bg-rose-50",
    countColorClass: "text-rose-600",
    viewAllTextKey: "dashboard.buttons.viewAllNotResponding",
    statusBadgeClass: "bg-rose-500 text-white shadow-md",
    viewAllPath: "/admin/profiles/not-responding",
  },
  {
    key: "free-profiles",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-blue-50 to-sky-50",
    navButtonClass: "bg-blue-600 text-white hover:bg-blue-700",
    buttonClass: "border-2 border-blue-600 text-blue-600 hover:bg-blue-50",
    countColorClass: "text-blue-600",
    viewAllTextKey: "dashboard.buttons.viewAllFree",
    statusBadgeClass: "bg-white/90 text-blue-700 shadow",
    viewAllPath: "/admin/profiles/all?filter=free",
  },
  {
    key: "paid-profiles",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-green-50 to-emerald-50",
    navButtonClass: "bg-green-600 text-white hover:bg-green-700",
    buttonClass: "border-2 border-green-600 text-green-600 hover:bg-green-50",
    countColorClass: "text-green-600",
    viewAllTextKey: "dashboard.buttons.viewAllPaid",
    statusBadgeClass: "bg-white/90 text-green-700 shadow",
    viewAllPath: "/admin/profiles/all?filter=paid",
  },
  {
    key: "redzone-profiles",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-red-50 to-rose-50",
    navButtonClass: "bg-red-600 text-white hover:bg-red-700",
    buttonClass: "border-2 border-red-600 text-red-600 hover:bg-red-50",
    countColorClass: "text-red-600",
    viewAllTextKey: "dashboard.buttons.viewAllRedzone",
    statusBadgeClass: "bg-white/90 text-red-700 shadow",
    viewAllPath: "/admin/profiles/all?filter=redzone",
  },
  {
    key: "pending-male",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-amber-50 to-orange-50",
    navButtonClass: "bg-orange-500 text-white hover:bg-orange-600",
    buttonClass:
      "border-2 border-orange-500 text-orange-600 hover:bg-orange-50",
    countColorClass: "text-orange-600",
    countLabelKey: "dashboard.count.pending",
    viewAllTextKey: "dashboard.buttons.reviewPendingMale",
    statusBadgeClass: "bg-orange-500 text-white shadow-md",
    viewAllPath: "/admin/profiles/male/pending",
  },
  {
    key: "pending-female",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-yellow-50 to-amber-50",
    navButtonClass: "bg-amber-500 text-white hover:bg-amber-600",
    buttonClass: "border-2 border-amber-500 text-amber-600 hover:bg-amber-50",
    countColorClass: "text-amber-600",
    countLabelKey: "dashboard.count.pending",
    viewAllTextKey: "dashboard.buttons.reviewPendingFemale",
    statusBadgeClass: "bg-amber-500 text-white shadow-md",
    viewAllPath: "/admin/profiles/female/pending",
  },
  {
    key: "other-male",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-teal-50 to-green-50",
    navButtonClass: "bg-teal-500 text-white hover:bg-teal-600",
    buttonClass: "border-2 border-teal-500 text-teal-600 hover:bg-teal-50",
    countColorClass: "text-teal-600",
    viewAllTextKey: "dashboard.buttons.exploreOtherMale",
    statusBadgeClass: "bg-white/90 text-teal-700 shadow",
    viewAllPath: "/admin/profiles/male/other",
  },
  {
    key: "other-female",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-emerald-50 to-lime-50",
    navButtonClass: "bg-emerald-500 text-white hover:bg-emerald-600",
    buttonClass:
      "border-2 border-emerald-500 text-emerald-600 hover:bg-emerald-50",
    countColorClass: "text-emerald-600",
    viewAllTextKey: "dashboard.buttons.exploreOtherFemale",
    statusBadgeClass: "bg-white/90 text-emerald-700 shadow",
    viewAllPath: "/admin/profiles/female/other",
  },
  {
    key: "other-mediator",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-slate-50 to-gray-50",
    navButtonClass: "bg-slate-700 text-white hover:bg-slate-800",
    buttonClass: "border-2 border-slate-700 text-slate-700 hover:bg-slate-50",
    countColorClass: "text-slate-700",
    viewAllTextKey: "dashboard.buttons.viewAllOtherMediator",
    statusBadgeClass: "bg-white/90 text-slate-700 shadow",
    viewAllPath: "/admin/profiles/all?filter=createdByOtherMediator",
  },
  {
    key: "shortlisted",
    title: "",
    profiles: [],
    headerGradientClass: "bg-gradient-to-r from-purple-50 to-red-50",
    navButtonClass: "bg-purple-600 text-white hover:bg-purple-700",
    buttonClass:
      "border-2 border-purple-600 text-purple-600 hover:bg-purple-50",
    countColorClass: "text-purple-600",
    countLabelKey: "dashboard.count.shortlisted",
    viewAllTextKey: "dashboard.buttons.viewAllShortlisted",
    statusBadgeClass: "bg-emerald-500 text-white shadow-md",
    viewAllPath: "/admin/profiles/all/shortlisted",
  },
];

export const PAYMENT_STATUS_SECTION_MAP = {
  free: "free-profiles",
  paid: "paid-profiles",
  redzone: "redzone-profiles",
} as const;

export const DASHBOARD_SCROLL_POSITION_KEY = "bureau_dashboard_scroll_position";

export const DASHBOARD_SCROLL_SECTION_KEY =
  "bureau_dashboard_scroll_section_key";

export const DASHBOARD_SCROLL_SECTION_OFFSET_KEY =
  "bureau_dashboard_scroll_section_offset";

export const WEBSITE_ROUTES = {
  editWebsite: "/admin/profile/edit",
  editTerms: "/admin/website/terms",
  editBusinessVideo: "/admin/website/links",
  sliderImages: "/admin/website/images",
  editLocations: "/admin/website/locations",
  editStories: "/admin/website/stories",
  editTestimonials: "/admin/website/testimonials",
  editPackages: "/admin/website/packages",
  editServices: "/admin/website/services",
  navbarLogo: "/admin/website/logo",
  editSocial: "/admin/website/social",
} as const;

export const SECTION_BADGES: Record<
  string,
  {
    label: string;
    className: string;
  }
> = {
  "my-male": {
    label: "New",
    className: "bg-violet-600",
  },
  "my-female": {
    label: "New",
    className: "bg-violet-600",
  },
  "callback-profiles": {
    label: "Call Back",
    className: "bg-orange-500",
  },
  "not-responding-profiles": {
    label: "Not Responding",
    className: "bg-rose-500",
  },
  "free-profiles": {
    label: "Interested",
    className: "bg-blue-500",
  },
  "paid-profiles": {
    label: "Paid",
    className: "bg-emerald-500",
  },
  "redzone-profiles": {
    label: "Red Zone",
    className: "bg-red-500",
  },
  "pending-male": {
    label: "Incomplete",
    className: "bg-amber-500",
  },
  "pending-female": {
    label: "Incomplete",
    className: "bg-amber-500",
  },
  "other-male": {
    label: "Other Bureau",
    className: "bg-teal-500",
  },
  "other-female": {
    label: "Other Bureau",
    className: "bg-teal-500",
  },
  "other-mediator": {
    label: "Mediator",
    className: "bg-slate-600",
  },
  shortlisted: {
    label: "Shortlisted",
    className: "bg-pink-500",
  },
};
